package com.essntl.features.itinerary.ui.itinerary_overview

sealed interface ItineraryOverviewNavigation {
    data class EditItinerary(val itineraryId: String) : ItineraryOverviewNavigation
    data class EditInvoice(val proposalId: String, val invoiceId: String) : ItineraryOverviewNavigation
    data class AddInvoice(val proposalId: String) : ItineraryOverviewNavigation
}